import DynamicTable from "./DynamicTable";

export default DynamicTable;
